/**
 * Escapes all special markdown characters in a string by prepending a backslash.
 * This ensures user input is always rendered as plain text rather than markdown.
 * Already-escaped sequences (e.g. \*) are left untouched, making the function idempotent.
 *
 * Characters escaped: \ ` * _ { } [ ] < > ( ) # + - . ! |
 * Reference: https://www.markdownguide.org/basic-syntax/#escaping-characters
 */
const SPECIAL = '\\\\`*_{}\\[\\]<>()+\\-.!|#';
const ESCAPE_RE = new RegExp(`(\\\\[${SPECIAL}])|([${SPECIAL}])`, 'g');

export const escapeMarkdown = (text: string): string => {
  if (!text) return text ?? '';
  return text.replace(ESCAPE_RE, (match, alreadyEscaped, needsEscaping) =>
    alreadyEscaped !== undefined ? match : `\\${needsEscaping}`
  );
};
